import React, { useContext, useEffect, useState, useMemo } from "react";
import * as locales from '@mui/material/locale';
import { useTheme, ThemeProvider, createTheme } from "@mui/material/styles";
import api from '../../services/api';
// import Typography from '@mui/material/Typography';
import { DataGrid } from '@mui/x-data-grid';
import FreteGratis from './../Pages/FreteGratis/FreteGratis';
import Cem_porcento from '../../assets/img/100.svg';
import { fontSize } from '@mui/system';
import CardFilial from '../../components/CardFilial/CardFilial';
import { BrowserView, MobileView } from 'react-device-detect';

import {
  Grid,
  Typography,
  Container,
  Box,
  Paper
} from "@material-ui/core";

function Gratis(props) {
  const [freteGratis, setFreteGratis] = useState([]);
  const [cidadeSelecionada, setCidadeSelecionada] = useState(0);
  const [filialClicada, setFilialClicada] = useState({});
  const [feito, setFeito] = useState(false);
  const [posicao, setPosicao] = useState([]);
  const [locale, setLocale] = useState('ptBR');
  const theme = useTheme();
  const themeWithLocale = useMemo(() => createTheme(theme, locales[locale]), [locale, theme]);

  useEffect(() => {
    if (!feito) {
      BuscarFiliais(0);
    }
    setFeito(true);
  }, []);

  function BuscarFiliais(filial = 0) {
    api.get(`Clientes/ClienteFiliais/${filial}`)
      .then(CheckError)
      .then((response) => {
        return response;
      })
      .then((data) => {
        setPosicao(data.data);
        //     setMapaCarregado(true);
      })
      .catch((error) => {
        console.log(error.message)
      });
  }

  function BuscarCidadesFreteGratis() {
    api.get(`/Gratis`)
      .then(CheckError)
      .then((response) => {
        return response;
      })
      .then((data) => {
        setFreteGratis(data.data);
      })
      .catch((error) => {
        console.log(error.message)
      });
  }

  function CheckError(response) {
    console.log("CHECK AAAA");
    if (response.status >= 200 && response.status <= 299) {
      console.log("CHECK BBBB", response);
      return response;
    } else {
      console.log(response.statusText);
    }
  }

  useEffect(() => {
    BuscarCidadesFreteGratis();
  }, []);

  const columns = [
    { field: 'cidade', headerName: 'Cidade', width: 210, editable: false },
    { field: 'uf', headerName: 'UF', width: 25, editable: false },
    {
      field: 'distritos',
      headerName: 'Abrange os Distritos',
      width: 360,
      editable: false,
    },
    {
      field: 'excecoesBairros',
      headerName: 'Exceto Bairros',
      width: 170,
      editable: false,
    }
  ];

  const localizedTextsMap = {
    columnMenuUnsort: "Não Ordenado",
    columnMenuSortAsc: "Ordem Crescente",
    columnMenuSortDesc: "Ordem Cecrescente",
    columnMenuFilter: "Filtro",
    columnMenuHideColumn: "Ocultar",
    columnMenuShowColumns: "Mostrar Colunas",
    columnHeaderSortIconLabel: 'Ordenar',
    noRowsLabel: 'Nenhuma Linha',
    footerTotalRows: 'Total de Linhas:',
    filterPanelOperators: 'Operador',
    filterPanelColumns: 'Coluna',
    filterPanelInputLabel: 'Valor',
    filterOperatorContains: 'contém',
    filterOperatorEquals: 'igual',
    filterOperatorStartsWith: 'começa com',
    filterOperatorEndsWith: 'termina com',
    filterOperatorIs: 'é',
    filterOperatorNot: 'não é',
    filterOperatorAfter: 'depois de',
    filterOperatorOnOrAfter: 'igual ou depois',
    filterOperatorBefore: 'antes de',
    filterOperatorOnOrBefore: 'igual ou antes',
    filterOperatorIsEmpty: 'é vazio',
    filterOperatorIsNotEmpty: 'não é vazio',
    filterOperatorIsAnyOf: 'é qualquer um',
    filterPanelInputPlaceholder: 'Pesquisar',
    toolbarFiltersTooltipActive: (count) =>
      count !== 1 ? `${count} filtro ativo` : `${count} filtros ativos`,
    footerTotalVisibleRows: (visibleCount, totalCount) =>
      `${visibleCount.toLocaleString()} de ${totalCount.toLocaleString()}`,
    footerRowSelected: (count) =>
      count !== 1
        ? `${count.toLocaleString()} Linhas Selecionadas`
        : `${count.toLocaleString()} Linha Selecionada`,
  };

  let _filial = Array.from(cidadeSelecionada);

  console.log("RRRRR", freteGratis);

  let dadosFilial = freteGratis.map((e) => e).filter(e => e.cidade_id == _filial[0]).map(a => a.filiais);
  let myFilial = (dadosFilial[0]?.trim().split(","))?.filter(r => r);
  let resultFilial = posicao.map((p) => p).filter(p => p.filial == myFilial);
  let clickFilial = freteGratis.map((e) => e).filter(e => e.cidade_id == _filial[0]).map(a => a);

  return (
    <>
      <BrowserView>
        <ThemeProvider theme={themeWithLocale}>
          <Container>
            <Box sx={{ marginTop: 8 }}>
              <Typography variant="h6">Condições Gerais em Fretes ou Delivery Grátis</Typography>
            </Box>
            <Grid
              container
              spacing={3}
              direction="row"
              justify="center"
              alignItems="stretch"
            >
              <Grid item xs={12}>
                <Typography>Frete Grátis Para Cidades Brasileiras Relacionadas Abaixo:</Typography>
              </Grid>
              <Grid item xs={8}>
                <Grid style={{ height: "100%", minHeight: '700px', width: "100%" }}>
                  <DataGrid
                    headerHeight={35}
                    getRowId={(freteGratis) => freteGratis.cidade_id}
                    rows={freteGratis}
                    onSelectionModelChange={(ids) => {
                      const selectedIDs = new Set(ids);
                      const selectedRowData = freteGratis.filter((row) =>
                        selectedIDs.has(row.cidade_id.toString())
                      )
                      setCidadeSelecionada(selectedIDs);
                    }}
                    columns={columns}
                    pageSize={20}
                    rowHeight={34}
                    rowSelection={'single'}
                    // checkboxSelection
                    // disableSelectionOnClick
                    localeText={localizedTextsMap}
                    sx={{ fontSize: '12px', fontWeight: 'bold' }}
                    selectionModel={freteGratis[0]}
                  />
                </Grid>
              </Grid>

              <Grid item xs={4}>
                <Grid container >
                  <Grid item xs={12}>
                    <img src={Cem_porcento} alt="100% Grátis" sx={{ display: { xs: 'none', md: 'flex' } }} style={{ width: '120px', height: 'auto', marginTop: '-70px' }} />
                  </Grid>
                  <Grid item xs={12}>
                    <div style={{ height: 300, width: '100%' }}>
                      <CardFilial posicao={resultFilial} clickFilial={clickFilial} />
                    </div>
                  </Grid>
                  <Grid item xs={12} style={{ position: "relative", marginTop: 28 }}>
                    <Typography>Clique na Cidade ao Lado e Veja a Sua Filial Para Atendimentos</Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Container >
        </ThemeProvider>
      </BrowserView>

      <MobileView>
        <ThemeProvider theme={themeWithLocale}>
          <Container>
            <Box sx={{ marginTop: 8, marginBottom: 65 }}>
              <Typography variant="h6">Condições Gerais em Fretes ou Delivery Grátis</Typography>
            </Box>
            <Grid
              container
              spacing={1}
              direction="row"
              justify="center"
              alignItems="stretch"
            >
              <Grid item xs={12}>
                <Grid container >
                  <Grid item xs={12}>
                    <img src={Cem_porcento} alt="100% Grátis" sx={{ display: { xs: 'none', md: 'flex' } }} style={{ width: '120px', height: 'auto', marginTop: '-70px' }} />
                  </Grid>
                  <Grid item xs={12}>
                    <div style={{ height: 310, width: '100%' }}>
                      <CardFilial posicao={resultFilial} clickFilial={clickFilial} sx={{ width:'50%'}} />
                    </div>
                  </Grid>
                  <Grid item xs={12} style={{ position: "relative", marginTop: 28 }}>
                    <Typography>Clique na Cidade Abaixo e Veja a Sua Filial Para Atendimentos</Typography>
                  </Grid>
                </Grid>
              </Grid>


              <Grid item xs={12}>
                <Typography>Frete Grátis Para Cidades Brasileiras Relacionadas Abaixo:</Typography>
              </Grid>
              <Grid item xs={12}>
                <Grid style={{ height: "100%", minHeight: '700px', width: "100%" }}>
                  <DataGrid
                    headerHeight={35}
                    getRowId={(freteGratis) => freteGratis.cidade_id}
                    rows={freteGratis}
                    onSelectionModelChange={(ids) => {
                      const selectedIDs = new Set(ids);
                      const selectedRowData = freteGratis.filter((row) =>
                        selectedIDs.has(row.cidade_id.toString())
                      )
                      setCidadeSelecionada(selectedIDs);
                    }}
                    columns={columns}
                    pageSize={20}
                    rowHeight={34}
                    rowSelection={'single'}
                    // checkboxSelection
                    // disableSelectionOnClick
                    localeText={localizedTextsMap}
                    sx={{ fontSize: '12px', fontWeight: 'bold' }}
                    selectionModel={freteGratis[0]}
                  />
                </Grid>
              </Grid>

            </Grid>
          </Container >
        </ThemeProvider>
      </MobileView>

    </>

  )
}

export default Gratis